<template>
  <b-col cols="12" class="lf-footer">
    <b-row>
      <b-col md="3" class="lf-footer__column">
        <div class="lf-footer__badge lf-footer__badge--empty"></div>
        <div class="lf-footer__title">Viaggia con {{ site.brand }} {{ site.payoff }}</div>
        <ul class="lf-footer__links">
          <li>
            <router-link :to="{ name: 'about' }">Cos’è {{ site.name }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'homepage' }">Prenota un viaggio</router-link>
          </li>
        </ul>
      </b-col>

      <b-col md="3" class="lf-footer__column">
        <div class="lf-footer__badge">
          <vb-icon name="shield" :size="16" :color="sass('gray-900')" />
        </div>
        <div class="lf-footer__title">Legal</div>
        <ul class="lf-footer__links">
          <li>
            <router-link :to="{ name: 'terms' }">Termini e condizioni</router-link>
          </li>
          <li v-if="site.urlPrivacy">
            <a :href="site.urlPrivacy" target="_blank" rel="noopener">Privacy Policy</a>
          </li>
          <li v-if="site.urlCookiePolicy">
            <a :href="site.urlCookiePolicy" target="_blank" rel="noopener">Cookie Policy</a>
          </li>
        </ul>
      </b-col>

      <b-col md="3" class="lf-footer__column">
        <div class="lf-footer__badge">
          <vb-icon name="envelope" :size="16" :color="sass('gray-900')" />
        </div>
        <div class="lf-footer__title">Supporto</div>
        <ul class="lf-footer__links">
          <li>
            <router-link :to="{ name: 'faq' }">Contatta l’assistenza clienti</router-link>
          </li>
        </ul>
      </b-col>
    </b-row>

    <div class="lf-footer__bottom">
      <span>© {{ current_year }} Salabam Solutions</span>
      <router-link :to="{ name: 'faq' }" class="lf-footer__contact">
        <vb-icon name="envelope" :size="14" :color="sass('gray-900')" />
        Contattaci
      </router-link>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "site-footer",
  data() {
    return {
      site: this.$config.site,
      current_year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
.lf-footer {
  text-align: left;

  &__column {
    margin-bottom: $grid-gutter-width;
  }

  &__badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-bottom: $grid-gutter-width / 4;
    background-color: $gray-200;
    border-radius: 50%;

    &--empty {
      visibility: hidden;

      @include media-breakpoint-down(sm) {
        display: none;
      }
    }
  }

  &__title {
    margin-bottom: $grid-gutter-width / 3;
    font-size: $font-size-base;
    font-weight: $vb-font-weight-semibold;
    color: $gray-900;
  }

  &__links {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      margin-bottom: $grid-gutter-width / 6;
      font-size: $font-size-md;
      line-height: 1.4;
    }
  }

  a {
    display: inline;
    color: $gray-900;

    &:visited,
    &:active {
      color: $gray-900;
    }

    &:hover,
    &:focus {
      color: $gray-900;
      text-decoration: underline;
    }
  }

  &__bottom {
    display: flex;
    flex-wrap: wrap;
    gap: $grid-gutter-20 / 2;
    align-items: center;
    justify-content: space-between;
    padding: $grid-gutter-width 0;
    font-size: $font-size-md;
    color: $gray-900;
    border-top: 1px solid $gray-200;
  }

  & &__contact {
    display: inline-flex;
    gap: $grid-gutter-width / 6;
    align-items: center;
  }
}
</style>
